import { useCallback, useState } from 'react';
import { ErrorCode } from 'utils/errorMessages';

export type ErrorsState = Record<string, string | undefined>;

const useApiErrorHandling = (
  mapCodeToFieldErrors: (code: ErrorCode, url?: string) => ErrorsState,
) => {
  const [apiErrors, setApiErrors] = useState<ErrorsState>({});

  const handleApiError = useCallback(
    (code: ErrorCode, url?: string) => {
      setApiErrors((previousErrors) => ({ ...previousErrors, ...mapCodeToFieldErrors(code, url) }));
    },
    [setApiErrors, mapCodeToFieldErrors],
  );

  const clearApiError = (type: string) => {
    setApiErrors((previousErrors) => {
      if (type) {
        return { ...previousErrors, [type]: undefined };
      }
      return {};
    });
  };

  return { apiErrors, handleApiError, clearApiError };
};

export default useApiErrorHandling;
